






























































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import { Month, MonthNames } from "../../shared/Month";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import SettingsJson from "../../shared/SettingsJson";
import BirthdayTimeSlotJson, { validateBirthdayTimeSlotJson } from "../../shared/BirthdayTimeSlotJson";

import { validateSettingsJson } from "../../shared/SettingsJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

type keysForParseInt = {
  [key in keyof Pick<
    SettingsJson,
    | "deleteUserDataAfterDays"
    | "membershipPaymentDaysAhead"
    | "collectionDateDaysAfterInvoiceDate"
    | "birthdaysCanRequestUntilDaysAhead"
    | "birthdayMaxCountSimultanous"
    | "groupBookingCanRequestUntilDaysAhead"
  >]: string;
};

export default Vue.extend({
  name: "SettingsGeneral",
  components: {
    PointerMenu,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    userActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      UserPermissionRank: UserPermissionRank,
      MonthNames: MonthNames,
      checkModuleIsActivated: checkModuleIsActivated,
      settingsData: null as SettingsJson | null,
      cachedBirthdayAltMaxCountSimultanousMonths: [] as Month[],
      toValidate: {} as any,
      validation: null as ValidationResult<SettingsJson> | null,
      hasChanges: false as boolean,
      showHints: {
        timeSlots: false,
      },
      isSaveDataLoading: false,
    };
  },
  created() {
    this.$emit("resetAppFrameButtons");
    this.loadData();
  },
  mounted() {
    this.setCachedBirthdayAltMaxCountSimultanousMonths();
  },
  methods: {
    loadData() {
      this.loadSettings();
    },

    async loadSettings() {
      this.settingsData = null;

      try {
        this.settingsData = await this.restClient.getSettings();

        this.$nextTick(() => {
          this.hasChanges = false;
        });
      } catch (e) {
        alert(e.message);
      }

      this.setCachedBirthdayAltMaxCountSimultanousMonths();
    },

    async saveAppSettings() {
      if (this.settingsData != null) {
        this.validation = validateSettingsJson(this.settingsData);

        if (this.validation != null && this.validation.isValid == true) {
          this.isSaveDataLoading = true;

          try {
            this.settingsData = await this.restClient.saveSettings(this.settingsData);

            this.$emit("reloadSettings");

            this.$nextTick(() => {
              this.hasChanges = false;
            });
          } catch (e) {
            alert("Speichern fehlgeschlagen: " + e.message);
          }

          this.isSaveDataLoading = false;
        } else {
          alert("Die Daten konnten nicht gespeichert werden. Bitte prüfen Sie Ihre Angaben.");
        }
      }
    },

    discardChanges() {
      this.toValidate = {};
      this.loadSettings();
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.settingsData != null) {
        this.validation = validateSettingsJson(this.settingsData);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    addBirthdayLocation() {
      if (this.settingsData) {
        this.settingsData.eventLocations.push("");
      }
    },

    removeBirthdayLocation(index: number) {
      if (this.settingsData) {
        this.settingsData.eventLocations.splice(index, 1);

        delete this.toValidate["eventLocations-" + index];
      }
    },

    addBirthdayTimeSlots() {
      if (this.settingsData) {
        this.settingsData.birthdayTimeSlots.push({
          beginTime: "",
          endTime: "",
          isWeekendOnly: false,
        });

        this.showHints.timeSlots = true;
      }
    },

    removeBirthdayTimeSlots(index: number) {
      if (this.settingsData) {
        this.settingsData.birthdayTimeSlots.splice(index, 1);

        delete this.toValidate["birthdayTimeSlots-" + index];
        this.showHints.timeSlots = true;
      }
    },

    /*** START control cached data ***/

    /* set cached data */

    setCachedBirthdayAltMaxCountSimultanousMonths() {
      if (this.settingsData != null) {
        if (this.settingsData.birthdayAltMaxCountSimultanousMonths == null) {
          this.cachedBirthdayAltMaxCountSimultanousMonths = [];
        } else {
          this.cachedBirthdayAltMaxCountSimultanousMonths = this.settingsData.birthdayAltMaxCountSimultanousMonths;
        }
      }
    },

    /* format and set data where be cached */

    formatAndSetBirthdayAltMaxCountSimultanousMonths() {
      if (this.settingsData != null) {
        if (this.cachedBirthdayAltMaxCountSimultanousMonths.length > 0) {
          this.settingsData.birthdayAltMaxCountSimultanousMonths = this.cachedBirthdayAltMaxCountSimultanousMonths;
        } else {
          this.settingsData.birthdayAltMaxCountSimultanousMonths = null;
        }
      }
    },

    /*** END control cached data ***/

    parseNumberInputs(input: keyof keysForParseInt) {
      if (this.settingsData != null) {
        this.settingsData[input] = +this.settingsData[input];
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    settingsData: {
      deep: true,
      handler() {
        this.hasChanges = true;
      },
    },

    hasChanges: {
      deep: true,
      handler() {
        this.$emit("changesInChild", this.hasChanges);
      },
    },
  },
  computed: {
    parseBirthdayAltMaxCountSimultanous: {
      get(): number | null | undefined {
        if (this.settingsData != null) {
          return this.settingsData.birthdayAltMaxCountSimultanous;
        }
      },
      set(value: string) {
        if (this.settingsData != null) {
          if (value == "") {
            this.settingsData.birthdayAltMaxCountSimultanous = null;
          } else {
            this.settingsData.birthdayAltMaxCountSimultanous = parseInt(value);
          }
        }
      },
    },
  },
});
